<template>
  <div id="salaryTotal">
    <van-nav-bar
        title="数据展示"
        right-text="刷新"
        left-arrow
        left-text="返回"
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
<!--    <van-row type="flex" justify="center">-->
<!--      <van-col span="20">-->
<!--        <div style="height: 300px" ref="productionCar"></div>-->
<!--      </van-col>-->
<!--    </van-row>-->
  </div>
</template>
<script>
import {Toast} from "vant";

export default {
  data () {
    return {

    }
  },
  methods: {
    loading () {
    },
    onClickLeft () {
      this.$router.go(-1);
    },
    onClickRight () {
      this.loading()
      Toast('已刷新');
    },
  },
  mounted () {
    this.loading()
  }
}
</script>